import Markdown from 'shared/components/Markdown';

import { fontImportUrl } from 'dashboard/components/ThemedFonts/ThemedFonts';
import TextBase from 'inquiry/components/TextBase';
import { useApply } from 'inquiry/lib/jsonLogic';
import useExternalStylesheet from 'lib/hooks/useExternalStylesheet';
import { TextComponent } from 'lib/interfaces/ui-components';
import { Inquiry } from 'verify/models/inquiry';

interface TextProps {
  component: TextComponent;
  inquiry: Inquiry;
}

const Text = ({ component, inquiry }: TextProps) => {
  const { text, hidden } = component.attributes;

  useExternalStylesheet(fontImportUrl(component.styles?.['font-family'].base.base));

  const apply = useApply(component.name, inquiry.attributes['next-step'].name);
  const isHidden = apply<boolean>(hidden);

  if (isHidden) {
    return null;
  }

  return (
    <TextBase data-test={component.type} styles={component.styles}>
      <Markdown>{text}</Markdown>
    </TextBase>
  );
};

export default Text;
